export const DEFAULT_DEPARTMENTS = [
  { code: '211', name: 'Oral Surgery' },
  { code: '404', name: 'Periodontics' },
  { code: '305', name: 'Conservative' },
  { code: '308', name: 'Prosthodontics' },
  { code: '406', name: 'Pedodontics' },
  { code: '407', name: 'Orthodontics' },
  { code: '208', name: 'Radiology' }
]

/**
 * Multi-select chips. Selection order = referral sequence (shown as a badge).
 * Props: value: [{deptCode, deptName}], onChange
 */
export default function ReferralChips({ value, onChange, master }) {
  const DEPARTMENTS = master && master.length ? master.map((m) => ({ code: m.deptCode, name: m.deptName })) : DEFAULT_DEPARTMENTS
  const idx = (code) => value.findIndex((v) => v.deptCode === code)
  const toggle = (d) => {
    const i = idx(d.code)
    if (i >= 0) onChange(value.filter((v) => v.deptCode !== d.code))
    else onChange([...value, { deptCode: d.code, deptName: d.name }])
  }
  return (
    <div className="chips">
      {DEPARTMENTS.map((d) => {
        const i = idx(d.code)
        return (
          <button type="button" key={d.code} className={`chip ref ${i >= 0 ? 'on' : ''}`} onClick={() => toggle(d)}>
            {i >= 0 && <em>{i + 1}</em>}
            {d.name} – {d.code}
          </button>
        )
      })}
    </div>
  )
}
